<template>
  <!-- 大区配置 -->
  <div class="Box">
    <el-card>
      <div style="margin-bottom: 20px">
        <!-- 新增 -->
        <el-button size="small" type="primary" @click="addRegion">{{ $t('GlobalSetObj.add') }}</el-button>
      </div>
      <el-table
        ref="tableRef"
        :data="tableDate"
        :max-height="600"
        border
        :header-cell-style="{ background: '#f2f2f2' }"
      >
        <el-table-column
          :label="$t('collectionCenter.ind')" align="center" type="index"
          width="60"
        >
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('collectionCenter.regionNameZh')"
          prop="zhName"
          align="center"
        /><!-- 大区名称—中文 -->
        <el-table-column
          :label="$t('collectionCenter.regionNamePu')"
          prop="puName"
          align="center"
        /><!-- 大区名称—葡语 -->
        <el-table-column
          :label="$t('GlobalSetObj.LatestModifiedBy')"
          prop="updateUserName"
          align="center"
        /><!-- 最新修改人 -->
        <el-table-column
          :label="$t('GlobalSetObj.LastModified')"
          prop="updateTime"
          align="center"
        /><!-- 最新修改时间 -->
        <el-table-column
          :label="$t('collectionCenter.operation')"
          fixed="right"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip
              :content="$t('GlobalSetObj.edit')" class="item" effect="dark"
              placement="top"
            >
              <el-button
                size="mini"
                style="color: #666; margin-right: 10px"
                type="text"
                @click="edit(scope.row)"
              >
                <i class="el-icon-edit-outline" style="font-size: 20px;" />
              </el-button>
            </el-tooltip>

            <el-tooltip
              :content="$t('GlobalSetObj.Delete')" class="item" effect="dark"
              placement="top"
            >
              <el-popconfirm
                :title="$t('collectionCenter.deleteSure')"
                @confirm="del(scope.row)"
              ><!-- 确定删除吗？ -->
                <i slot="reference" class="el-icon-delete" style="font-size: 20px;" />
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="right">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="search"
          @size-change="search1"
        />
      </div>
    </el-card>

    <el-dialog
      :title="$t('collectionCenter.addRegion')"
      :visible.sync="isAddRegion"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
      @close="closeRegion"
    >
      <div>
        <el-form ref="addRegionRef" :model="addRegionForm" label-position="top">
          <el-row>
            <el-col :span="24">
              <el-form-item
                prop="zhName"
                :label="$t('collectionCenter.regionNameZh')"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change'] }
                ]"
              >
                <el-input
                  v-model="addRegionForm.zhName" maxlength="100" show-word-limit
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                prop="puName"
                :label="$t('collectionCenter.regionNamePu')"
                :rules="[
                  { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur','change'] }
                ]"
              >
                <el-input
                  v-model="addRegionForm.puName" maxlength="100" show-word-limit
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="closeRegion">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button type="primary" @click="submitRegion">
          {{ $t('GlobalSetObj.determine') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  regionPage,
  regionAdd,
  regionUpdate,
  regionDelete
} from '@/api/resource/regionConfig';
export default {
  name: 'RegionConfig',
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {}
      },
      total: 0,
      tableDate: [],
      isAddRegion: false,
      addRegionForm: {
        zhName: '',
        puName: ''
      },
      isEdit: false
    };
  },
  created() {
    this.search();
  },
  methods: {
    search1() {
      this.queryForm.pageNumber = 1;
      this.search();
    },
    search() {
      regionPage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableDate = res.data.records;
        }
      });
    },
    edit(row) {
      this.isEdit = true;
      this.addRegionForm = {
        id: row.id,
        zhName: row.zhName,
        puName: row.puName
      };
      const loading = this.$loading({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: 'loading...',
        background: 'rgba(250, 250, 250, 0.6)'
      });
      setTimeout(() => {
        this.isAddRegion = true;
        loading.close();
      }, 600);
    },
    del(row) {
      const form = {
        id: row.id
      };
      regionDelete(form).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('collectionCenter.DeleteSucceeded'));
          this.search();
        }
      });
    },
    addRegion() {
      this.addRegionForm = {
        zhName: '',
        puName: ''
      };
      if (this.$refs.addRegionRef) {
        this.$refs.addRegionRef.resetFields();
      }
      this.isAddRegion = true;
    },
    closeRegion() {
      this.addRegionForm = {
        zhName: '',
        puName: ''
      };
      if (this.$refs.addRegionRef) {
        this.$refs.addRegionRef.resetFields();
      }
      this.isAddRegion = false;
      this.isEdit = false;
    },
    submitRegion() {
      this.$refs['addRegionRef'].validate((valid) => {
        if (valid) {
          if (!this.isEdit) {
            regionAdd(this.addRegionForm).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('collectionCenter.addSuccessful'));
                this.closeRegion();
                this.search();
              }
            });
          } else {
            regionUpdate(this.addRegionForm).then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('collectionCenter.ModificationSuccessful'));
                this.closeRegion();
                this.search();
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.Box{
  padding: 20px;
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
